{
  "login": {
    "title": "Connexion",
    "description": "Identifiez-vous avec votre mot de passe et le code de votre application d’authentification.",
    "username": "Nom d’utilisateur",
    "password": "Mot de passe",
    "totp": "Code de vérification",
    "totpHint": "Code à 6 chiffres affiché par votre application d’authentification.",
    "submit": "Se connecter",
    "submitting": "Connexion en cours…"
  },
  "validation": {
    "usernameRequired": "Saisissez votre nom d’utilisateur.",
    "passwordRequired": "Saisissez votre mot de passe.",
    "totpFormat": "Le code doit contenir exactement 6 chiffres."
  },
  "errors": {
    "invalidCredentials": "Identifiants incorrects.",
    "locked": "Trop de tentatives. Réessayez dans 15 minutes.",
    "unavailable": "La connexion est momentanément indisponible. Réessayez dans un instant.",
    "invalidRequest": "Requête invalide. Vérifiez les champs saisis.",
    "sessionExpired": "Votre session a expiré. Reconnectez-vous."
  },
  "logout": {
    "action": "Se déconnecter",
    "pending": "Déconnexion…"
  }
}
